import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from "react-redux";
import LoadingBox from "../../../../../components/LoadingBox";
import { SiteService } from "../../../../../util/services/site";
import { selectDashboard, selectViewMode } from '../../../../../util/store/selectors';
import { useSelector } from "../../../../../util/store/store";
import { getStatusOfOp, showErrorResponse } from "../../../../../util/varibles/global";
import { IOperation } from "../../../../../util/varibles/interface";
import { VIEW_MODE } from "../../../../../util/varibles/permission";
import { dashboardActions } from "../../../reducer";
import stylesParent from "../../style.module.scss";
import Operation from "./Operation";
import styles from "./style.module.scss";

interface IProps {
}

const Operations: React.FC<IProps> = () => {
    const [search, setSearch] = useState('');
    const operations = useSelector(selectDashboard.operations);
    const opsSite = useSelector(selectDashboard.opsSite);
    const loading = useSelector(selectDashboard.loadingOp);
    const mode = useSelector(selectViewMode);
    const dispatch = useDispatch();

    const [loadingOpSite, setLoadingOpSite] = useState<boolean>(false);

    useEffect(() => {
        if (mode === VIEW_MODE.SITE) {
            setLoadingOpSite(true)
            SiteService.dashboard()
                .then(res => {
                    const { operations } = res;
                    dispatch(dashboardActions.updateOpsSite(operations))
                    setLoadingOpSite(false)
                })
                .catch(error => {
                    setLoadingOpSite(false)
                    showErrorResponse("Get data failure", error);
                })
        }
    }, [dispatch, mode]);

    const handleKeyDown = (e: any) => {
        if (e.key === 'Escape') {
            setSearch('')
        }
    };

    const handleSearch = (e: any) => setSearch(e.target.value.trim());

    const value = search.toLowerCase();
    const renders = useMemo(() => {
        const isAllow = (data: IOperation) => {
            const {
                operation: { operation_code, current_process },
                activity_log
            } = data;
            const statusTxt = getStatusOfOp({
                operation: data.operation,
                current_process,
                activity_log,
            });
            return operation_code.toLowerCase().indexOf(value) !== -1 || statusTxt.toLowerCase().indexOf(value) !== -1
        }
        if (mode === VIEW_MODE.SITE) {
            return Object.keys(opsSite).reduce((list: React.ReactNode[], key) => {
                const item = opsSite[key];
                const allow = isAllow(item);
                if (allow)
                    return [...list, <Operation key={item.operation.id} data={item} />]
                return list;
            }, [])
        }
        else {
            return operations.reduce((list: React.ReactNode[], item) => {
                const allow = isAllow(item);
                if (allow)
                    return [...list, <Operation key={item.operation.id} data={item} />]
                return list;
            }, [])
        }
    }, [mode, operations, opsSite, value])

    return <>
        <div className={stylesParent.header}>
            Upcoming operations
        </div>
        <div className={stylesParent.body}>
            <div className={styles.wrapperSearch}>
                <Input
                    className={styles.search}
                    value={search}
                    onChange={handleSearch}
                    onKeyDown={handleKeyDown}
                    placeholder='Search for vessel name, Operation code, Operation stat...'
                    suffix={<SearchOutlined style={{ fontSize: '18px' }} />}
                />
            </div>
            <div className={stylesParent.operations}>
                {renders.length === 0 ?
                    <LoadingBox
                        className='mt-5'
                        loading={loadingOpSite || loading}
                        message="There is no ongoing operation today."
                    /> : renders}
            </div>
        </div>
    </>;
};

export default Operations;

